import React, { useEffect, useState } from "react";
import {
  GetChallengeById,
  updateChallageDetails,
  serachByLeads,
  gatAllOackageWithoutPagination,
  getAssignLeadsByGroupId,
  // deleteGroupChallenge,
} from "api/challengers/ChallengersApi";
import moment from "moment";
import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Grid,
  Row,
  Button,
  Tooltip,
  OverlayTrigger,
  Table,
  Modal,
} from "react-bootstrap";
import NotificationSystem from "react-notification-system";
import Card from "components/Card/Card";
import Select from "react-select";
import Datetime from "react-datetime";
import "../../../assets/css/demo.css";
import Axios from "axios";
import Swal from "sweetalert2";

const EditChallenge = (props) => {
  const _notificationSystem = React.createRef();
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const [challengeId, setChallengeId] = useState();
  const [name, setName] = useState("");
  const [startDateError, setStartDateError] = useState(null);
  const [nameError, setNameError] = useState(null);
  const [endDateError, setEndDateError] = useState(null);
  const [packageError, setPackageError] = useState(null);
  const [endDate, setEndDate] = useState("");
  const [selectTypeError, setSelectTypeError] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [organisationObject, setOrganisationObject] = useState("");
  const [organizationList, setOrganizationList] = useState([]);
  const [challengeType, setChallengeType] = useState("");
  const [subscriberItems, setSubscriberItems] = useState([]);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [challengeDetails, setChallengeDetails] = useState(null);
  const [urlError, setUrlError] = useState(null);
  const [url, setUrl] = useState("");
  const [getLeadsDetails, setGetLeadsDetails] = useState([]);
  const [getLeadsAssign, setGetLeadsAssign] = useState([]);
  const [loading, setloading] = useState(false);
  const [checkStartDateEndDateError, setCheckStartDateEndDateError] =
    useState(null);
  const [teamForms, setTeamForms] = useState([]);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    getAllOrganizationList();
    const id = window.location.pathname.split("editChallenge/")[1];
    setChallengeId(id);

    GetChallengeById(id, obj).then((res) => {
      if (res && res.data) {
        const data = res.data;
        setChallengeDetails(data);
        setName(data.name);
        setStartDate(data.start_date);
        setEndDate(data.end_date);
        setOrganisationObject({
          value: data.catalogue_package_title.id,
          label: data.catalogue_package_title.title,
        });
        setChallengeType(data.type || "");
        setUrl(data.dashboard_url || "");

        const groups = data.challenge_groups || [];
        const defaultTeamForms = groups.map((group) => {
          const leadDetails =
            group.lead_challenge_group.flatMap(
              (leadGroup) => leadGroup.lead_details || []
            ) || [];

          const subscribers = leadDetails.map((lead) => ({
            label: lead.name,
            value: lead.id,
          }));

          return {
            id: group.id,
            name: group.name || "",
            code: group.product_code || "",
            logo: group.profile_url || "",
            logoData: group.profile_url || "",
            subscriber: subscribers,
            showAssign: true,
          };
        });

        setTeamForms(defaultTeamForms);
      }
    });
  }, []);
  const getAssignLeads = (id) => {
    const notification = _notificationSystem.current;
    getAssignLeadsByGroupId(id, obj).then((res) => {
      if (res && Array.isArray(res) && res.length > 0) {
        const allLeadDetails = [];
        res.forEach((item) => {
          if (item.lead_details) {
            const users = item.lead_details.map((lead) => ({
              ...lead,
              member_id: item.id,
            }));
            allLeadDetails.push(...users);
          }
        });

        if (allLeadDetails.length > 0) {
          setGetLeadsAssign(res);
          setGetLeadsDetails(allLeadDetails);
          setOpenModal(true);
        } else {
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
              <div>
                <b>No leads found for this group.</b>
              </div>
            ),
            level: "error",
            position: "bl",
            autoDismiss: 15,
          });
        }
      } else {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift" />,
          message: (
            <div>
              <b>No leads found for this group.</b>
            </div>
          ),
          level: "error",
          position: "bl",
          autoDismiss: 15,
        });
      }
    });
  };

  const toggleAssignLeads = (index) => {
    const updatedForms = [...teamForms];
    updatedForms[index].showAssign = !updatedForms[index].showAssign;
    setTeamForms(updatedForms);
  };

  const onInputChange = (inputValue, actionMeta) => {
    if (actionMeta.action !== "input-change") return;
    if (typingTimeout) clearTimeout(typingTimeout);
    if (inputValue.trim().length === 0) return;
    const timeout = setTimeout(() => {
      handleSearch(inputValue.trim());
    }, 300);
    setTypingTimeout(timeout);
  };
  const handleEnterUrl = (event) => {
    const url = event.target.value;
    setUrl(url);
    if (url) {
      setUrlError(null);
    }
  };

  const handleSearch = async (searchTerm) => {
    try {
      const res = await serachByLeads(searchTerm, obj);
      const data = Array.isArray(res.data.data) ? res.data.data : [];
      const items = data.map((x) => ({
        value: x.id,
        label: `${x.lead_name} (${x.mobile_no})`,
      }));
      setSubscriberItems(items);
    } catch (err) {
      console.error("Search error", err);
      setSubscriberItems([]);
    }
  };
  const handleEnterName = (event) => {
    const enterName = event.target.value;
    setName(enterName);
    if (enterName) {
      setNameError(null);
    }
  };
  const getAllOrganizationList = () => {
    gatAllOackageWithoutPagination(obj).then((res) => {
      const organisationList = res.data.data.map((item) => {
        return {
          value: item.id,
          label: item.title,
        };
      });
      setOrganizationList(organisationList);
    });
  };
  const handleClick = () => {
    let hasError = false;
    setNameError(null);
    setUrlError(null);
    setStartDateError(null);
    setEndDateError(null);
    setCheckStartDateEndDateError(null);
    setPackageError(null);
    setSelectTypeError(null);

    if (!name) {
      hasError = true;
      setNameError(
        <small className="text-danger" style={{ marginLeft: "8px" }}>
          Name is required.
        </small>
      );
    }

    if (!url) {
      hasError = true;
      setUrlError(
        <small className="text-danger" style={{ marginLeft: "8px" }}>
          Dashboard Url is required.
        </small>
      );
    }

    if (!startDate) {
      hasError = true;
      setStartDateError(
        <small className="text-danger" style={{ marginLeft: "8px" }}>
          Start Date is required.
        </small>
      );
    }

    if (!endDate) {
      hasError = true;
      setEndDateError(
        <small className="text-danger" style={{ marginLeft: "8px" }}>
          End Date is required.
        </small>
      );
    }

    if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
      hasError = true;
      setCheckStartDateEndDateError(
        <small className="text-danger" style={{ marginLeft: "8px" }}>
          End Date must be after Start Date.
        </small>
      );
    }

    if (!organisationObject) {
      hasError = true;
      setPackageError(
        <small className="text-danger" style={{ marginLeft: "8px" }}>
          Package is required.
        </small>
      );
    }

    if (!challengeType) {
      hasError = true;
      setSelectTypeError(
        <small className="text-danger" style={{ marginLeft: "8px" }}>
          Select Type is required.
        </small>
      );
    }

    if (hasError) return;

    Swal.fire({
      width: "500px",
      title: "<strong><font size='36px'>Are Sure</font></strong>",
      icon: "info",
      html: "<font size='4px'>You want to save this changes</font>",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "<font size='4px'>Yes</font>",
      cancelButtonText: "<font size='4px'>No</font>",
    }).then((result) => {
      if (result.isConfirmed) {
        handleOnSubmit();
      }
    });
  };

  const handleOnSubmit = async () => {
    const notification = _notificationSystem.current;

    const teamData = (teamForms || []).map((form) => ({
      group_id: form.id ? form.id : null,
      name: form.name,
      product_code: form.code,
      profile_url: typeof form.logoData === "string" ? form.logoData : "",
      assign_leads: form.subscriber
        ? form.subscriber.map((s) => Number(s.value))
        : [],
    }));

    const challenge = {
      name,
      start_date: startDate,
      end_date: endDate,
      package_id: organisationObject.value || null,
      type: challengeType || null,
      teams: teamData,
      dashboard_url: url,
      is_active: true,
    };

    try {
      await updateChallageDetails(challengeId, challenge, obj);
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift" />,
        message: (
          <div>
            <b>Challenges</b> – Updated successfully.
          </div>
        ),
        level: "success",
        position: "bl",
        autoDismiss: 15,
      });

      // Reset form
      setName("");
      setUrl("");
      setStartDate("");
      setEndDate("");
      setOrganisationObject(null);
      setChallengeType("");
      setTeamForms([]);

      setTimeout(() => {
        props.history.push("/admin/Challengers");
      }, 3000);
    } catch (msg) {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift" />,
        message: (
          <div>
            <b>{msg}</b>
          </div>
        ),
        level: "error",
        position: "bl",
        autoDismiss: 15,
      });
    }
  };
  const handleAddForm = () => {
    setTeamForms([
      ...teamForms,
      {
        name: "",
        code: "",
        logo: "",
        logoData: "",
        showAssign: false,
        subscriber: [],
      },
    ]);
  };
  const handleEnter = (index, event) => {
    const newForms = [...teamForms];
    newForms[index].name = event.target.value;
    setTeamForms(newForms);
  };
  const handleCode = (index, event) => {
    const newForms = [...teamForms];
    newForms[index].code = event.target.value;
    setTeamForms(newForms);
  };
  const pushImage = (index) => {
    document.getElementById(`selectImageProfile-${index}`).click();
  };
  // const handleCLickDelete = (id) => {
  //   Swal.fire({
  //     width: "500px",
  //     title: "<strong><font size='36px'>Are Sure</font></strong>",
  //     icon: "info",
  //     html: "<font size='4px'>You want to delete this</font>",
  //     showCloseButton: true,
  //     showCancelButton: true,
  //     focusConfirm: false,
  //     confirmButtonText: "<font size='4px'>Yes</font>",
  //     cancelButtonText: "<font size='4px'>No</font>",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       deleteGroupMember(id);
  //     }
  //   });
  // };
  // const deleteGroupMember = async (id) => {
  //   const notification = _notificationSystem.current;
  //   const res = await deleteGroupChallenge(id, obj);

  //   if (res.message === "Group Challenge Member Deleted Successfully") {
  //     notification.addNotification({
  //       title: <span data-notify="icon" className="pe-7s-gift"></span>,
  //       message: (
  //         <div>
  //           <b>{res.data.message}</b>
  //         </div>
  //       ),
  //       level: "success",
  //       position: "bl",
  //       autoDismiss: 15,
  //     });
  //     setOpenModal(false);
  //     setloading(true);
  //   } else {
  //     notification.addNotification({
  //       title: <span data-notify="icon" className="pe-7s-gift"></span>,
  //       message: (
  //         <div>
  //           <b>{res.data.message}</b>
  //         </div>
  //       ),
  //       level: "success",
  //       position: "bl",
  //       autoDismiss: 15,
  //     });
  //     setOpenModal(false);
  //   }
  // };

  const handleImageChange = async (index, e) => {
    const file = e.target.files[0];
    const fdata = new FormData();
    fdata.append("company_logo", file);
    const token = JSON.parse(localStorage.getItem("user")).token;

    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_NOT_SECRET_CODE}/b2b/comapany/logo`,
        fdata,
        {
          headers: {
            Authorization: "Bearer " + token,
            "X-Country-Code": "BD",
            "X-Client-Name": "WEBSITE",
            "X-Client-Version": "123",
            "X-Request-Id": "124",
          },
        }
      );

      const imageUrl = res.data.data.company_logo_url;
      const newForms = [...teamForms];
      newForms[index].logo = file;
      newForms[index].logoData = imageUrl;
      setTeamForms(newForms);
    } catch (error) {
      console.error("Image upload error", error);
    }
  };
  const onSubscriberChange = (selected, index) => {
    const updatedForms = [...teamForms];
    updatedForms[index].subscriber = selected;
    setTeamForms(updatedForms);
  };

  const handleSelectStartDate = (value) => {
    if (!value || !moment(value).isValid()) {
      setStartDate("");
      setStartDateError("Start Date is required");
      return;
    }

    const start_date = moment(value).format("YYYY-MM-DD");
    setStartDate(start_date);
    setStartDateError(null);
  };
  const validStartDate = (current) => {
    return current.isSameOrAfter(moment(), "day");
  };

  const handleSelectEndDate = (value) => {
    if (!value || !moment(value).isValid()) {
      setEndDate("");
      setEndDateError("End Date is required");
      setCheckStartDateEndDateError(null);
      return;
    }

    const end_date = moment(value).format("YYYY-MM-DD");
    setEndDate(end_date);
    setEndDateError(null);

    if (startDate && moment(startDate).isAfter(moment(end_date))) {
      setCheckStartDateEndDateError(
        <small className="text-danger" style={{ marginLeft: "8px" }}>
          Start Date must be before or equal to End Date.
        </small>
      );
    } else {
      setCheckStartDateEndDateError(null);
    }
  };

  const handleChangePackage = (value) => {
    setOrganisationObject(value);
    if (value) {
      setPackageError(null);
    }
  };
  const removeForm = (index) => {
    const updatedForms = [...teamForms];
    updatedForms.splice(index, 1);
    setTeamForms(updatedForms);
  };

  const removeValue = () => {
    setOpenModal(false);
  };

  const Assign = <Tooltip id="Assign"> View Assign Leads</Tooltip>;
  return (
    <div className="main-content">
      <Grid fluid>
        <NotificationSystem ref={_notificationSystem} />
        <Row>
          <Col md={6}>
            <Card
              content={
                <form>
                  <FormGroup>
                    <ControlLabel>Challenge Name</ControlLabel>
                    <FormControl
                      type="text"
                      name="name"
                      placeholder="Enter Name"
                      onChange={handleEnterName}
                      value={name}
                      style={{ width: "100%" }}
                    />
                    {nameError}
                  </FormGroup>

                  <FormGroup>
                    <ControlLabel>Start Date</ControlLabel>
                    <Datetime
                      timeFormat={false}
                      dateFormat="YYYY-MM-DD"
                      closeOnSelect
                      value={startDate || ""}
                      isValidDate={validStartDate}
                      onChange={handleSelectStartDate}
                      inputProps={{
                        placeholder: "Select Start Date",
                        style: { width: "100%" },
                      }}
                    />
                    {startDateError}
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>End Date</ControlLabel>
                    <Datetime
                      timeFormat={false}
                      dateFormat="YYYY-MM-DD"
                      closeOnSelect
                      value={endDate || ""}
                      isValidDate={validStartDate}
                      onChange={handleSelectEndDate}
                      inputProps={{
                        placeholder: "Select End Date",
                        style: { width: "100%" },
                      }}
                    />
                    {checkStartDateEndDateError} {endDateError}
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>Select Package</ControlLabel>
                    <Select
                      style={{ width: "100%" }}
                      value={organisationObject}
                      placeholder="Select Package"
                      options={organizationList}
                      onChange={(value) => handleChangePackage(value)}
                      isDisabled={true}
                    />
                    {packageError}
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>Select Type</ControlLabel>
                    <select
                      onChange={(event) => {
                        setChallengeType(event.target.value);
                        if (event.target.value) {
                          setSelectTypeError(null);
                        }
                      }}
                      name=""
                      value={challengeType}
                      className="form-control"
                    >
                      <option value="">Challenge type</option>
                      <option value="steps">steps</option>
                      <option value="calorie">calorie</option>
                    </select>
                    {selectTypeError}
                  </FormGroup>
                  <FormGroup>
                    <ControlLabel>Dashboard Url</ControlLabel>
                    <FormControl
                      type="text"
                      name="Dashboard Url"
                      placeholder="Dashboard Url"
                      onChange={handleEnterUrl}
                      value={url}
                      style={{ width: "100%" }}
                    />
                    {urlError}
                  </FormGroup>
                  <div>
                    <Button onClick={handleAddForm}>
                      Add Team <i className="fa fa-plus"></i>
                    </Button>

                    {teamForms.length > 0 && (
                      <>
                        <br />
                        <br />
                        {teamForms.map((form, index) => (
                          <div
                            key={index}
                            style={{
                              width: "90%",
                              margin: "0 auto",
                              boxShadow:
                                "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
                              padding: "20px",
                              marginBottom: "20px",
                              borderRadius: "8px",
                              backgroundColor: "#f3f3f3",
                              position: "relative",
                            }}
                          >
                            <button
                              type="button"
                              onClick={(e) => {
                                e.preventDefault();
                                Swal.fire({
                                  width: "500px",
                                  title:
                                    "<strong><font size='36px'>Are You Sure?</font></strong>",
                                  icon: "warning",
                                  html: "<font size='4px'>You want to remove this Team?</font>",
                                  showCloseButton: true,
                                  showCancelButton: true,
                                  focusConfirm: false,
                                  confirmButtonText:
                                    "<font size='4px'>Yes</font>",
                                  cancelButtonText:
                                    "<font size='4px'>No</font>",
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    removeForm(index);
                                  }
                                });
                              }}
                              style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                background: "transparent",
                                border: "none",
                                fontSize: "20px",
                                cursor: "pointer",
                                color: "#999",
                              }}
                              title="Remove Form"
                            >
                              &times;
                            </button>

                            <div
                              style={{
                                display: "flex",
                                gap: "20px",
                                marginBottom: "10px",
                              }}
                            >
                              <FormGroup style={{ flex: 1 }}>
                                <ControlLabel>Team Name</ControlLabel>
                                <FormControl
                                  type="text"
                                  placeholder="Enter Name"
                                  onChange={(e) => handleEnter(index, e)}
                                  value={form.name}
                                />
                              </FormGroup>

                              <FormGroup style={{ flex: 1 }}>
                                <ControlLabel>Team Code</ControlLabel>
                                <FormControl
                                  type="text"
                                  placeholder="Product Code"
                                  onChange={(e) => handleCode(index, e)}
                                  value={form.code}
                                />
                              </FormGroup>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                gap: "20px",
                                alignItems: "center",
                              }}
                            >
                              <FormGroup>
                                <ControlLabel>Upload Team Logo</ControlLabel>
                                <br />
                                <input
                                  style={{ display: "none" }}
                                  id={`selectImageProfile-${index}`}
                                  type="file"
                                  accept="image/*"
                                  className="form-control"
                                  onChange={(e) => handleImageChange(index, e)}
                                />
                                <Button
                                  onClick={() => pushImage(index)}
                                  style={{ color: "#2B3A41" }}
                                >
                                  <i
                                    className={
                                      form.logo === ""
                                        ? "fa fa-plus"
                                        : "fa fa-pencil fa-fw"
                                    }
                                  ></i>{" "}
                                  {form.logo === ""
                                    ? "Choose Logo"
                                    : "Change Logo"}
                                </Button>
                              </FormGroup>

                              {(form.logoData || form.logo) && (
                                <img
                                  src={
                                    typeof form.logoData === "string"
                                      ? form.logoData
                                      : typeof form.logo === "string"
                                      ? form.logo
                                      : URL.createObjectURL(form.logo)
                                  }
                                  alt="Logo"
                                  style={{
                                    width: "80px",
                                    height: "80px",
                                    objectFit: "cover",
                                    borderRadius: "6px",
                                    marginLeft: "10px",
                                  }}
                                />
                              )}
                            </div>
                            {/* {form.showAssign &&
                            Array.isArray(form.subscriber) &&
                            form.subscriber.length > 0 ? ( */}
                            <div
                              style={{
                                gap: "10px",
                                flex: 1,
                                alignItems: "end",
                              }}
                            >
                              <div style={{ marginBottom: "16px" }}>
                                <Button
                                  onClick={() => toggleAssignLeads(index)}
                                >
                                  Assign Leads <i className="fa fa-user-plus" />
                                </Button>
                              </div>
                              {form.showAssign && (
                                <div style={{ flex: 1 }}>
                                  <FormGroup>
                                    <ControlLabel>Select Leads</ControlLabel>
                                    <Select
                                      className="react-select primary"
                                      classNamePrefix="react-select"
                                      name="subscriber"
                                      isClearable={false}
                                      closeMenuOnSelect={false}
                                      value={form.subscriber}
                                      onChange={(selected) =>
                                        onSubscriberChange(selected, index)
                                      }
                                      onInputChange={onInputChange}
                                      isMulti
                                      options={subscriberItems}
                                      placeholder="Type Name or Phone Number"
                                      noOptionsMessage={() =>
                                        "No Subscribers Found"
                                      }
                                    />
                                  </FormGroup>
                                </div>
                              )}
                            </div>
                            {/* ) : ( */}
                            <>
                              <div style={{ display: "flex", gap: "20px" }}>
                                <div style={{ display: "contents" }}>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={Assign}
                                  >
                                    <Button
                                      simple
                                      bsStyle="danger"
                                      bsSize="xs"
                                      style={{
                                        border: "none",
                                        marginTop: "8px",
                                      }}
                                      onClick={() => getAssignLeads(form.id)}
                                    >
                                      <i
                                        className="fa fa-id-badge"
                                        style={{ fontSize: "20px" }}
                                      />
                                    </Button>
                                  </OverlayTrigger>
                                </div>
                              </div>
                            </>
                            {/* )} */}
                          </div>
                        ))}
                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                          <Button
                            onClick={handleAddForm}
                            className="add-button"
                          >
                            Add Team <i className="fa fa-plus"></i>
                          </Button>
                        </div>
                      </>
                    )}
                  </div>
                  <Button
                    className="btn-color"
                    onClick={() => handleClick()}
                    style={{ marginTop: "20px" }}
                  >
                    Update
                  </Button>
                </form>
              }
            />
            <Modal
              backdrop="static"
              keyboard={false}
              show={openModal}
              onHide={() => setOpenModal(false)}
              bsSize="lg"
            >
              <Modal.Header closeButton>
                <Modal.Title>List of Assign Leads</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Table>
                  {getLeadsDetails && getLeadsDetails.length > 0 ? (
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Mobile No</th>
                          {/* <th>Action</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {getLeadsDetails.map((lead) => (
                          <tr key={lead.id}>
                            <td>{lead.name}</td>
                            <td>{lead.mobile_no}</td>
                            {/* <td>
                              <Button
                                className="btn-simple btn btn-xs btn-danger"
                                simple
                                bsStyle="success"
                                bsSize="xs"
                                style={{ border: "none" }}
                                onClick={() =>
                                  handleCLickDelete(lead.member_id)
                                }
                              >
                                <i class="fa fa-times" />
                              </Button>
                            </td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p style={{ textAlign: "center" }}>
                      No leads found for this group.
                    </p>
                  )}
                </Table>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="btn-fill btn btn-info"
                  variant="secondary"
                  onClick={() => removeValue()}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

export default EditChallenge;
